import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import BaseModal from '../../../_shared/components/BaseModal';
import { ModalContainer, CancelButton, DeleteButton } from './Styles';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  filter: PropTypes.objectOf(PropTypes.any)
};

const defaultProps = {
  filter: {}
};

const DeleteInfoModal = ({ isOpen, closeModal, filter }) => {
  return (
    <BaseModal isOpen={isOpen} width={490} padding="36px" isClickEscClose>
      <ModalContainer>
        <ModalContainer.Header>
          <FormattedMessage id="list.filters.delete.header" />
        </ModalContainer.Header>
        <ModalContainer.Body>
          <FormattedMessage
            id="list.filters.delete.body"
            values={{ filterTitle: filter?.title }}
          />
        </ModalContainer.Body>
        <ModalContainer.Footer>
          <CancelButton onClick={() => closeModal(false, filter)}>
            <FormattedMessage id="list.filters.delete.cancel" />
          </CancelButton>
          <DeleteButton onClick={() => closeModal(true, filter)}>
            <FormattedMessage id="list.filters.delete.delete" />
          </DeleteButton>
        </ModalContainer.Footer>
      </ModalContainer>
    </BaseModal>
  );
};

DeleteInfoModal.propTypes = propTypes;
DeleteInfoModal.defaultProps = defaultProps;

export default DeleteInfoModal;
